import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=93bb93e0&"
import script from "./VersionHistory.vue?vue&type=script&lang=ts&"
export * from "./VersionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=93bb93e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports